(() => {
  const HIT = "a, button, input, textarea, select, label, summary, [role='button']";

  function guard(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest(HIT)) return;
    if (!target.closest("slideshow-slides, slideshow-slide")) return;
    event.stopPropagation();
  }

  document.addEventListener("mousedown", guard, true);
  document.addEventListener("pointerdown", guard, true);
})();
